import axios from 'axios';
import { toast } from 'sonner';

export const API = process.env.REACT_APP_BACKEND_URL + '/api';
export const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const err = (e, fallback) => {
  const d = e.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-2).join(' ')}: ${x.msg}`).join('; ');
  return typeof d === 'string' ? d : fallback;
};

export const EMPTY_ADDR = { street: '', city: '', state: '', zip: '' };
export const newLine = (kind = 'custom', src = {}) => ({
  key: Math.random().toString(36).slice(2), kind, ref_id: src.id || null, name: src.name || '', description: src.description || '',
  quantity: 1, unit_price: src.unit_price ?? 0, discount_type: 'none', discount_value: 0,
});

export const blankForm = () => ({
  customer_id: null, save_as_customer: false, customer_name: '', customer_email: '', customer_phone: '', company_name: '',
  billing_address: { ...EMPTY_ADDR }, delivery_address: { ...EMPTY_ADDR }, items: [newLine()],
  invoice_discount_type: 'none', invoice_discount_value: 0, tax_exemption: null, tax_override: null,
  notes: '', internal_notes: '', payment_terms: 'due_on_receipt', due_date: new Date().toISOString().slice(0, 10), is_test: false,
});

const addr = (a) => ({ street: a?.street || '', city: a?.city || '', state: a?.state || '', zip: a?.zip || a?.zip_code || '' });

export const formFromInvoice = (inv) => ({
  ...blankForm(), customer_id: inv.customer_id || null, customer_name: inv.customer_name || '', customer_email: inv.customer_email || '',
  customer_phone: inv.customer_phone || '', company_name: inv.company_name || '', billing_address: addr(inv.billing_address),
  delivery_address: addr(inv.shipping_address),
  items: (inv.items || []).map((i) => ({ ...newLine(i.line_type || 'custom'), ref_id: i.ref_id || null, name: i.name || i.config?.product_type || '',
    description: i.description || '', quantity: i.quantity || 1, unit_price: i.unit_price ?? i.config?.unit_price ?? 0,
    discount_type: i.discount_type || 'none', discount_value: i.discount_value || 0 })),
  invoice_discount_type: inv.invoice_discount_type || 'none', invoice_discount_value: inv.invoice_discount_value || 0,
  tax_exemption: inv.tax_exemption || null, tax_override: inv.tax_override?.active ? inv.tax_override : null,
  notes: inv.notes || '', internal_notes: (inv.internal_notes || '').replace('TEST – DO NOT FULFILL / DO NOT SHIP', '').trim(),
  payment_terms: inv.payment_terms || 'due_on_receipt', due_date: (inv.due_date || '').slice(0, 10), is_test: !!inv.is_test,
});

export const payload = (f) => ({
  ...f, items: f.items.map(({ key, ...l }) => ({ ...l, quantity: Number(l.quantity) || 0, unit_price: Number(l.unit_price) || 0, discount_value: Number(l.discount_value) || 0 })),
  invoice_discount_value: Number(f.invoice_discount_value) || 0, due_date: f.due_date || null,
});

export const TERM_DAYS = { due_on_receipt: 0, net_7: 7, net_15: 15, net_30: 30, net_45: 45, net_60: 60 };
export const dueFor = (terms) => (TERM_DAYS[terms] == null ? null : new Date(Date.now() + TERM_DAYS[terms] * 864e5).toISOString().slice(0, 10));

export const copyPayLink = (id) => {
  navigator.clipboard.writeText(`${window.location.origin}/pay/invoice/${id}`);
  toast.success('Pay Now link copied');
};

export const postSend = async (token, id) => {
  try {
    const r = await axios.post(`${API}/admin/invoices/${id}/send`, {}, auth(token));
    toast.success(`Invoice emailed to ${r.data.to}`);
    return true;
  } catch (e) { toast.error(err(e, 'Could not send invoice')); return false; }
};
